module.exports = __webpack_public_path__ + "img/626-c7060b.png";